import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import { from, Device } from '@helpers/media';
import ParagraphStyles from '@stories/Components/Global/Typography/Paragraph.styles';
import styled, { css } from 'styled-components';
const Wrapper = styled.div `
  margin-bottom: 40px;

  ${({ centerText }) => centerText &&
    css `
      text-align: center;
    `}

  ${ParagraphStyles.Paragraph} {
    color: ${brand.grey.grey20};
    max-width: 820px;
    margin-left: auto;
    margin-right: auto;
  }
`;
const Title = styled.h1 `
  font-size: 24px;
  ${fonts.DaxPro['Medium']};
  color: ${brand.black};
  margin: 0 0 16px;

  @media ${from(Device.MobileLarge)} {
    font-size: 28px;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 35px;
  }
`;
export default {
    Wrapper,
    Title,
};
